export const PACE_VARIABLE_LIST = [
  {
    label: "Occupied Rooms",
    id: "1",
  },
  {
    label: "Revenue",
    id: "2",
  },
];
